import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils/bui';

@Component({
  selector: 'sidebar-section',
  exportAs: 'sidebarSection',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarSection {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-section',
      'flex flex-col',
      'px-2',

      // User classes
      this.userClass(),
    ),
  );
}

@Component({
  selector: 'sidebar-section-header',
  exportAs: 'sidebarSectionHeader',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarSectionHeader {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-section-header',
      'flex w-full items-center rounded-md select-none',
      'h-8 gap-x-1',

      // Active and hover states
      '[&]:has-[>button]:hover:bg-neutral-a3',
      'has-data-sidebar-section-header-active:bg-neutral-a3',

      // Everything except buttons
      '*:not-[button]:first:ms-1.5',
      '*:not-[button]:last:me-1.5',

      // Button
      '*:[button]:flex *:[button]:cursor-pointer *:[button]:items-center *:[button]:rounded-md *:[button]:text-left',
      '*:[button]:h-8 *:[button]:w-full *:[button]:min-w-0 *:[button]:gap-x-1',
      '*:[button]:first:ps-1.5',
      '*:[button]:last:pe-1.5',

      // Label
      '**:[sidebar-label]:text-sm **:[sidebar-label]:font-medium **:[sidebar-label]:text-neutral-a11',

      // Collapsible trigger
      '*:[collapsible-trigger:has(>sidebar-action)]:first:ms-0',
      '*:[collapsible-trigger:has(>sidebar-action)]:last:me-0',

      // User classes
      this.userClass(),
    ),
  );
}

@Component({
  selector: 'sidebar-section-content',
  exportAs: 'sidebarSectionContent',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarSectionContent {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-section-content',
      'flex flex-col',
      'mt-1 gap-y-0.5',

      // User classes
      this.userClass(),
    ),
  );
}
